import { render, staticRenderFns } from "./ProjectsBoard.vue?vue&type=template&id=f6cc5e5c"
import script from "./ProjectsBoard.vue?vue&type=script&lang=ts"
export * from "./ProjectsBoard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports